<template>
	<div>
		<!-- Start Footer Area  -->
		<footer v-if="data.showFooter" class="rn-footer footer-style-default variation-two">

			<!-- <div v-if="data.showCta" class="rn-callto-action clltoaction-style-default style-7">
                <div class="container">
                    <div class="row row--0 align-items-center content-wrapper">
                        <div class="col-lg-8 col-md-8">
                            <div class="inner" data-aos="fade-up">
                                <div class="content text-left">
                                    <Logo/>
                                    <p class="subtitle">
                                        If you want to create a corporate template you can purchase now our doob
                                        template.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4">
                            <div class="call-to-btn text-start mt_sm--20 text-lg-end" data-aos="fade-up">
                                <Button
                                    title="Purchase Doob"
                                    icon="arrow-right"
                                    url="#"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

			<div class="footer-top">
				<div class="container">
					<div class="row">
						<div class="col-lg-3 col-md-6 col-sm-6 col-12">
							<div class="rn-footer-widget">
								<h4 id="footerH4" class="title">公司总部</h4>
								<div class="inner">
									<ul class="footer-link link-hover footer-no-wrap">
										<li>
											<a>地址：大连市旅顺口区盐北路706号</a>
										</li>
										<li>
											<a>邮编：116045</a>
										</li>
										<li>
											<a>总机电话：0411-62682888</a>
										</li>
										<li>
											<a>销售热线：0411-62682889</a>
										</li>
										<li id="tech-support-phone">
											<a>技术支持(座机)：0411-62682868</a>
										</li>
										<li>
											<a>技术支持(手机)：13154116146</a>
										</li>
										<li>
											<a class="footer-email-link">E-mail：dcce62682888@163.com</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div class="col-lg-3 col-md-6 col-sm-6 col-12">
							<div class="rn-footer-widget">
								<h4 class="title">北方区域</h4>
								<div class="inner">
									<div class="footer-office-group">
										<h5 class="office-title">大连办事处</h5>
										<ul class="footer-link link-hover footer-no-wrap">
											<li>
												<a>高新园区学子街2号3-6-4</a>
											</li>
										</ul>
									</div>
									<div class="footer-office-group">
										<h5 class="office-title">沈阳办事处</h5>
										<ul class="footer-link link-hover footer-no-wrap">
											<li>
												<a>15940469009</a>
											</li>
										</ul>
									</div>
									<div class="footer-office-group">
										<h5 class="office-title">北京办事处</h5>
										<ul class="footer-link link-hover footer-no-wrap">
											<li>
												<a>18811051341 / 15210545580</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
						<div class="col-lg-3 col-md-6 col-sm-6 col-12">
							<div class="rn-footer-widget">
								<h4 class="title">南方区域</h4>
								<div class="inner">
									<div class="footer-office-group">
										<h5 class="office-title">深圳办事处</h5>
										<ul class="footer-link link-hover footer-no-wrap">
											<li>
												<a>宝安区福永镇福永大道福华大厦8H</a>
											</li>
											<li>
												<a>0755-27381925 / 13600197524</a>
											</li>
										</ul>
									</div>
									<div class="footer-office-group">
										<h5 class="office-title">华东营销总部(上海)</h5>
										<ul class="footer-link link-hover footer-no-wrap">
											<li>
												<a>021-39215640 / 13524856320</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
						<div class="col-lg-3 col-md-6 col-sm-6 col-12">
							<div class="rn-footer-widget footer-qrcode-section">
								<h4 class="title">关注我们</h4>
								<div class="inner">
									<div class="footer-qrcode-wrapper">
										<Logo logo-type="qcode"></Logo>
									</div>
									<h6 class="subtitle footer-qrcode-text">扫描关注微信公众号获取更多信息</h6>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<Newsletter v-if="data.showNewsletter" />
		</footer>
		<!-- End Footer Area  -->

		<Copyright v-if="data.showCopyright" />

		<ScrollTop />
	</div>
</template>

<script>
	import Copyright from './Copyright'
	import Button from '../../elements/button/Button'
	import Icon from '../../icon/Icon'
	import ScrollTop from './ScrollTop'
	import Logo from '../../elements/logo/Logo'
	import Newsletter from './Newsletter'

	export default {
		name: 'Footer',
		components: {
			Newsletter,
			Logo,
			ScrollTop,
			Icon,
			Button,
			Copyright
		},
		props: {
			data: {
				default: null
			}
		}
	}
</script>

<style scoped>
	.footer-qrcode-text {
		white-space: nowrap;
	}

	.footer-email-link {
		text-transform: none !important;
	}

	.footer-no-wrap a {
		white-space: nowrap;
	}

	.footer-office-group {
		margin-bottom: 24px;
	}

	.footer-office-group:last-child {
		margin-bottom: 0;
	}

	.office-title {
		color: #333;
		font-size: 14px;
		margin-bottom: 12px;
		font-weight: 600;
	}

	.footer-qrcode-section {
		text-align: center;
	}

	.footer-qrcode-wrapper {
		background: #fff;
		padding: 12px;
		border-radius: 8px;
		display: inline-block;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
		margin-bottom: 16px;
	}

	@media (max-width: 992px) {
		.footer-no-wrap a {
			white-space: normal;
		}
	}
</style>
